import { getActiveStoreId } from '../../../../../Utils/storeAccess';
import { formatCalendarDate } from '../../../../../Utils/calendarDate';

import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonLabel, IonLoading, IonModal, IonRow, IonTextarea, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { arrowBack, arrowBackOutline, cardOutline, copy, flash, walletOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import { cartApiHeaders } from '../../../../../Utils/cartApi';
import { cartNumber } from '../../../../../Utils/cartItem';
import { validateCheckoutCoupon } from '../../../../../Utils/cartCoupon';
import { DeliveryQuote, quoteStoreDelivery, readDeliverySelection, saveDeliveryQuote } from '../../../../../Utils/deliveryQuote';
import { armazenarProjeto, empresaCarregar, incluirProjeto, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import useAnalytics from '../../../../../hooks/useAnalytics';
import ConfirmarCelular from '../../../../Inicio/ConfirmarCelular/ConfirmarCelular';
import RevisarPedido from '../../../../Inicio/RevisarPedido/RevisarPedido';
import "./OrdensFechar.css";
import iconPix from "./imgs/pix.svg";

type Props = {
  produtos: any[];
  logado: any;
  desconto?: any;
  cupom?: string;
  resgateCashBack?: number;
  closeAction: Function;
  closeActionSimple: Function;
  onDeliveryChange?: (taxa: string, tempo: string) => void;
};

const OrdensFechar: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const buscarInputRef = useRef<any>(null);
  const [taxaEntrega, setTaxaEntrega] = useState<any>();
  const [showRevisarPedido, setShowRevisarPedido] = useState(false);
  const checkingDelivery = useRef(false);

  const { dadosEmpresa, setDadosEmpresa, verificarPagamentoPedido, pararVerificacaoPagamento } = useContext(MessageContext);

  const [showModalQrCode, setShowModalQrCode] = useState(false);
  const [qrCodeData, setQRCodeData] = useState<any>();
  const [qrCode, setQRCode] = useState<any>();
  const { idPagamento, setIdPagamento } = useContext(MessageContext);
  const { isPaymentCompleted, setIsPaymentCompleted } = useContext(MessageContext);
  const [valorPagamento, setValorPagamento] = useState<any>();

  const [timeLeft, setTimeLeft] = useState(6 * 60); // 10 minutos em segundos
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  const [arrayFormaPagamento, setArrayFormaPagamento] = useState<any[]>([]); // Array para armazenar campos dinâmicos
  const [precisaTroco, setPrecisaTroco] = useState<boolean>(false);


  // const [desconto, setDesconto] = useState('');
  const [taxaServico, setTaxaServico] = useState('');

  const [valorTotalProdutos, setValorTotalProdutos] = useState<any>();
  const [valorTotal, setValorTotal] = useState<any>();

  const { listaItemProdutos, setListaItemProdutos } = useContext(MessageContext);
  const analytics = useAnalytics();

  const [showModalConfirmarCelular, setShowModalConfirmarCelular] = useState(false);



  useEffect(() => {

    carregarProjeto();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.produtos]);

  useEffect(() => {

    try {
      let taxaServicoFloat = parseFloat(taxaServico?.replace(/\./g, '').replace(/\,/g, '.'));
      let descontoFloat = parseFloat(props.desconto?.replace(/\./g, '').replace(/\,/g, '.'));
      let taxaEntregaFloat = parseFloat(taxaEntrega?.replace(/\./g, '').replace(/\,/g, '.'));

      let valorTotalRecalculado = 0;
      if (valorTotalProdutos) {
        valorTotalRecalculado = parseFloat(valorTotalProdutos.replace(/\./g, '').replace(/\,/g, '.'));
      }

      if (taxaEntrega) {
        valorTotalRecalculado += (taxaEntregaFloat ? taxaEntregaFloat : 0);
      }

      if (props.desconto) {
        valorTotalRecalculado -= (descontoFloat ? descontoFloat : 0);
      }

      if (props.resgateCashBack) {
        valorTotalRecalculado -= (props.resgateCashBack ? props.resgateCashBack : 0);
      }

      if (taxaServico) {
        valorTotalRecalculado += (valorTotalRecalculado * (taxaServicoFloat / 100));
      }

      setValorTotal(valorTotalRecalculado.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));

    } catch (error) {
      console.log("erro ao calcular", error);
    }
  }, [taxaEntrega, taxaServico, props.desconto, props.resgateCashBack, valorTotalProdutos]);

  function carregarProjeto() {

    const consultar = async () => {
      setTaxaEntrega(localStorage.getItem("taxaEntrega") || "");

      // Calcula a nova soma dos valores após a remoção
      const totalValor = props.produtos.reduce((total: any, item: any) => {
        const itemValorNumerico = parseFloat(
          item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
        );
        return total + itemValorNumerico;
      }, 0);

      if (totalValor) {
        setValorTotalProdutos(totalValor?.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }));
      }
      else {
        setValorTotalProdutos("0,00");
      }

      if (totalValor) {
        setValorTotal(totalValor?.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }));
      }
      else {
        setValorTotal("0,00");
      }

      // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
      console.log("Nova soma dos valores:", totalValor);

      if (buscarInputRef.current) {
        buscarInputRef.current.setFocus();
      }
    }

    consultar();
  }

  const onChangeValorArray = (e: any, index: number) => {
    // e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    const novosCampos: any = [...arrayFormaPagamento];
    novosCampos[index].valor = v;
    setArrayFormaPagamento(novosCampos);

  };

  const moedaParaNumero = (valor: any): number => {
    if (typeof valor === "number") {
      return valor;
    }

    const valorNormalizado = String(valor || "")
      .replace(/[^\d,.-]/g, "")
      .replace(/\./g, "")
      .replace(/\,/g, ".");

    return parseFloat(valorNormalizado) || 0;
  };

  const numeroParaMoeda = (valor: number): string => {
    return (valor || 0).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const isPagamentoDinheiro = (campo: any): boolean => {
    const pagamento = String(campo?.pagamento || "").toLowerCase();
    const tipo = String(campo?.tipo || "").toLowerCase();
    return pagamento === "dinheiro" || tipo === "dinheiro";
  };

  const getIconeFormaPagamentoEntrega = (item: any) => {
    if (isPagamentoDinheiro({ pagamento: item?.nome, tipo: item?.tipo })) {
      return walletOutline;
    }

    return cardOutline;
  };

  const getPagamentoDinheiroIndex = (): number => {
    return arrayFormaPagamento.findIndex((campo: any) => isPagamentoDinheiro(campo));
  };

  const atualizarValorPagoDinheiro = (valor: string) => {
    setArrayFormaPagamento((formasPagamento: any[]) => {
      const dinheiroIndex = formasPagamento.findIndex((campo: any) => isPagamentoDinheiro(campo));

      if (dinheiroIndex === -1) {
        return formasPagamento;
      }

      const novasFormasPagamento = [...formasPagamento];
      novasFormasPagamento[dinheiroIndex] = {
        ...novasFormasPagamento[dinheiroIndex],
        valor,
      };

      return novasFormasPagamento;
    });
  };

  const selecionarPrecisaTroco = (precisa: boolean) => {
    setPrecisaTroco(precisa);

    if (precisa) {
      atualizarValorPagoDinheiro("");
      return;
    }

    atualizarValorPagoDinheiro(numeroParaMoeda(moedaParaNumero(valorTotal)));
  };

  const validarPagamentoDinheiro = (): boolean => {
    const dinheiroIndex = getPagamentoDinheiroIndex();

    if (dinheiroIndex === -1 || !precisaTroco) {
      return true;
    }

    const valorPago = moedaParaNumero(arrayFormaPagamento[dinheiroIndex]?.valor);
    const totalPedido = moedaParaNumero(valorTotal);

    if (!arrayFormaPagamento[dinheiroIndex]?.valor || valorPago <= 0) {
      setTextToast("Informe com quanto você vai pagar.");
      setShowToast(true);
      return false;
    }

    if (valorPago < totalPedido) {
      setTextToast("O valor informado deve ser maior ou igual ao total do pedido.");
      setShowToast(true);
      return false;
    }

    return true;
  };

  const renderPagamentoDinheiroDetalhes = (campo: any, index: number) => (
    <div className="dinheiro-card" onClick={(e) => e.stopPropagation()}>
      {/* <div className="dinheiro-card-header">
        <IonLabel className="dinheiro-card-title">Pagamento em dinheiro</IonLabel>
        <IonLabel className="dinheiro-total">Total do pedido: R$ {valorTotal || "0,00"}</IonLabel>
      </div> */}

      <IonLabel className="dinheiro-question">Você precisa de troco?</IonLabel>

      <div className="dinheiro-choice-row">
        <IonButton
          size="small"
          expand="block"
          fill={!precisaTroco ? "solid" : "outline"}
          className="dinheiro-choice-button"
          onClick={(e) => {
            e.stopPropagation();
            selecionarPrecisaTroco(false);
          }}
        >
          Sem troco
        </IonButton>
        <IonButton
          size="small"
          expand="block"
          fill={precisaTroco ? "solid" : "outline"}
          className="dinheiro-choice-button"
          onClick={(e) => {
            e.stopPropagation();
            selecionarPrecisaTroco(true);
          }}
        >
          Com troco
        </IonButton>
      </div>

      {precisaTroco && (
        <div className="dinheiro-troco-area">
          <IonLabel className="dinheiro-input-label">Vou pagar com</IonLabel>

          <div className="dinheiro-quick-row">
            {[20, 50, 100]
              .filter((valorRapido: number) => valorRapido >= moedaParaNumero(valorTotal))
              .map((valorRapido: number) => (
                <IonButton
                  key={valorRapido}
                  size="small"
                  fill="outline"
                  onClick={(e) => {
                    e.stopPropagation();
                    atualizarValorPagoDinheiro(numeroParaMoeda(valorRapido));
                  }}
                >
                  R$ {numeroParaMoeda(valorRapido)}
                </IonButton>
              ))}
          </div>

          <IonInput
            disabled={campo.pagou}
            clearInput={true}
            className="dinheiro-input"
            type="tel"
            maxlength={14}
            placeholder="Ex: 20,00"
            value={campo.valor || ''}
            onIonChange={(e: any) => onChangeValorArray(e, index)}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <div className="troco-row">
        <IonLabel className="troco-label">Troco:</IonLabel>
        <IonLabel className="troco-valor">R$ {calcularValorTroco(valorTotal, arrayFormaPagamento)}</IonLabel>
      </div>

      {/* {!precisaTroco && (
        <IonLabel className="dinheiro-helper-text">Cliente pagará o valor exato do pedido.</IonLabel>
      )} */}
    </div>
  );

  useEffect(() => {
    if (precisaTroco) {
      return;
    }

    setArrayFormaPagamento((formasPagamento: any[]) => {
      const dinheiroIndex = formasPagamento.findIndex((campo: any) => isPagamentoDinheiro(campo));

      if (dinheiroIndex === -1) {
        return formasPagamento;
      }

      const valorTotalFormatado = numeroParaMoeda(moedaParaNumero(valorTotal));

      if (formasPagamento[dinheiroIndex]?.valor === valorTotalFormatado) {
        return formasPagamento;
      }

      const novasFormasPagamento = [...formasPagamento];
      novasFormasPagamento[dinheiroIndex] = {
        ...novasFormasPagamento[dinheiroIndex],
        valor: valorTotalFormatado,
      };

      return novasFormasPagamento;
    });
  }, [valorTotal, precisaTroco]);

  useEffect(() => {

    if (isPaymentCompleted) {
      // Se o modal estiver aberto, fecha ele
      if (showModalQrCode) {
        setShowModalQrCode(false);
      }

      setIsPaymentCompleted(false);

      setListaItemProdutos([]);

      let empresaid = getActiveStoreId() || "";

      // ✅ Prioriza o contexto sobre o localStorage
      if (dadosEmpresa?.pk) {
        empresaid = dadosEmpresa.pk;
        console.log("🔄 isPaymentCompleted - Usando empresaid do contexto:", empresaid);
      }

      carregarEmpresa(empresaid);

      props.closeAction();
    }

  }, [isPaymentCompleted]);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (showModalQrCode) {
      // Reseta o contador para 10 minutos sempre que o modal é aberto
      setTimeLeft(6 * 60); // 10 minutos em segundos (10 * 60)

      // Inicia o intervalo de 1 segundo para o countdown
      timer = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime > 0) {
            return prevTime - 1;
          } else {
            clearInterval(timer); // Limpa o intervalo quando o tempo chega a 0
            // Quando o tempo acaba, redireciona o usuário
            handleQrCodeExpired();
            return 0;
          }
        });
      }, 1000);
    }

    // Limpa o timer quando o modal fecha ou o componente é desmontado
    return () => clearInterval(timer);

  }, [showModalQrCode]);

  // Função que será chamada quando o QR Code expira
  const handleQrCodeExpired = () => {
    setTextToast("Código expirado. Gere um novo para efetuar o pagamento.");
    setShowToast(true);

    setShowModalQrCode(false);
    pararVerificacaoPagamento(); // Para a verificação quando o QR Code expira
  };


  async function carregarEmpresa(loja: any, apenasLogo = false) {

    const consultar = async () => {

      requestService(empresaCarregar.url.replace("{id}", loja.replace(/#/g, '%23')), {
        method: empresaCarregar.method
      },
        history,
        (response: any) => {
          if (apenasLogo) {
            if (/^https?:\/\//.test(response.Item?.urlLogo || '')) {
              setDadosEmpresa((atual: any) => atual?.pk === response.Item.pk
                ? { ...atual, urlLogo: response.Item.urlLogo }
                : atual);
            }
          } else {
            setDadosEmpresa(response.Item);
          }
        },
        (error: any) => {
          console.log(error);
        },
        !apenasLogo);

    }

    await consultar();
  }



  // Função para definir a forma de pagamento (substitui ao invés de adicionar)
  const handleAdicionarFormaPagamento = (opcao: string, tipo: string) => {
    const valorTotalNumerico = moedaParaNumero(valorTotal);

    console.log("valorTotalNumerico", valorTotalNumerico);

    let uuid = crypto.randomUUID();
    console.log("uuid", uuid);

    // Cria a nova forma de pagamento
    const novoPagamento = {
      id: uuid,
      pagamento: opcao,
      tipo: tipo,
      valor: numeroParaMoeda(valorTotalNumerico),
    };

    setPrecisaTroco(false);

    // Substitui a forma de pagamento atual
    setArrayFormaPagamento([novoPagamento]);
    // Analytics: AddPaymentInfo
    try { analytics.trackAddPaymentInfo(opcao, valorTotalNumerico); } catch (e) { /* noop */ }
  };

  const handleRemoverFormaPagamento = (index: number) => {
    // Removendo o item pelo índice
    const formaPagamentoAtualizada = arrayFormaPagamento.filter(
      (_: any, i: any) => i !== index
    );

    // Atualizando o estado
    setArrayFormaPagamento(formaPagamentoAtualizada);
    // alterarFormaPagamento(formaPagamentoAtualizada);
  };

  function calcularValorRestante(valorTotal: string, arrayFormaPagamento: any[]): any {

    const totalPagamentos = arrayFormaPagamento.reduce((total: number, campo: any) => {
      return total + moedaParaNumero(campo.valor);
    }, 0);

    const valorTotalFloat = moedaParaNumero(valorTotal);

    // Calcula o valor restante e garante que não seja negativo
    const valorRestante = Math.max(0, valorTotalFloat - totalPagamentos);

    // Retorna o valor formatado
    return valorRestante;
  }

  function calcularValorTroco(valorTotal: string, arrayFormaPagamento: any[]): string {
    const totalPagamentos = arrayFormaPagamento.reduce((total: number, campo: any) => {
      return total + moedaParaNumero(campo.valor);
    }, 0);

    const valorTotalFloat = moedaParaNumero(valorTotal);

    // Calcula o valor restante, garantindo que não seja negativo
    const valorTroco = Math.max(0, totalPagamentos - valorTotalFloat);

    // Formata o valor restante para o padrão brasileiro (duas casas decimais, vírgula e ponto)
    return valorTroco.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function obterValorPagoDinheiro(arrayFormaPagamento: any[]): string {
    const pagamentoEmDinheiro = arrayFormaPagamento.find((campo: any) => {
      const nomePagamento = String(campo?.pagamento || campo?.tipo || '').toLowerCase();
      return nomePagamento === 'dinheiro';
    });

    return pagamentoEmDinheiro?.valor || '';
  }

  async function confirmarPedido() {
    const nomeLocal = (localStorage.getItem("nome") || "").trim();
    const telefoneLocal = (localStorage.getItem("telefone") || "").trim();
    const telefoneDigits = telefoneLocal.replace(/\D/g, "");
    console.log("telefoneDigits", telefoneDigits);
    const telefoneValido = telefoneDigits.startsWith("55") && (telefoneDigits.length === 13);

    if (!nomeLocal || !telefoneValido) {
      setTextToast("Informe nome e celular válidos.");
      setShowToast(true);
      setShowModalConfirmarCelular(true);
      return;
    }

    setShowRevisarPedido(true);
  }

  // Função para formatar a data no padrão brasileiro
  const formatarData = formatCalendarDate;

  // Função para formatar a hora
  function formatarHora(isoTime: string): string {
    if (!isoTime) return "";
    // Extrair a parte da hora do formato ISO (2025-12-01T18:10)
    const timePart = isoTime.includes('T') ? isoTime.split('T')[1] : isoTime;
    const [hora, minuto] = timePart.split(':');
    return `${hora}:${minuto}`;
  }

  function validarCupomAntesDeEnviar() {
    // Usa os itens atuais, sem aguardar os efeitos que recalculam o subtotal.
    // Isso também cobre um segundo envio imediatamente depois de um 409.
    const subtotalAtual = (listaItemProdutos || []).reduce((total: number, item: any) => total + cartNumber(item.subtotal), 0);
    const result = validateCheckoutCoupon(dadosEmpresa?.configuracoesCupom, props.cupom,
      props.desconto, subtotalAtual, taxaEntrega);
    if (!result.valid) {
      setTextToast(result.message || 'Revise o cupom antes de continuar.');
      setShowToast(true);
    }
    return result.valid;
  }

  function atualizarEntrega(quote: DeliveryQuote) {
    if (quote.empresaid !== dadosEmpresa?.pk || getActiveStoreId() !== quote.empresaid) return;
    saveDeliveryQuote(quote);
    setTaxaEntrega(quote.taxa);
    props.onDeliveryChange?.(quote.taxa, quote.tempo);
  }

  async function validarEntregaAntesDeEnviar() {
    if (checkingDelivery.current) return false;
    checkingDelivery.current = true;
    setShowLoading(true);
    const companyId = dadosEmpresa?.pk;
    const selection = readDeliverySelection();
    const previousTime = localStorage.getItem('tempoEntrega') || '';
    try {
      const quote = await quoteStoreDelivery(companyId, selection, undefined, true);
      if (getActiveStoreId() !== companyId || JSON.stringify(readDeliverySelection()) !== JSON.stringify(selection)) {
        throw new Error('Os dados da entrega mudaram. Revise o pedido antes de confirmar.');
      }
      atualizarEntrega(quote);
      if (cartNumber(quote.taxa) !== cartNumber(taxaEntrega) || quote.tempo !== previousTime) {
        setShowRevisarPedido(false);
        throw new Error('O frete ou prazo foi atualizado. Revise o pedido e confirme novamente.');
      }
      return true;
    } catch (failure) {
      setTextToast(failure instanceof Error ? failure.message : 'Não foi possível validar a entrega. Tente novamente.');
      setShowToast(true);
      return false;
    } finally {
      checkingDelivery.current = false;
      setShowLoading(false);
    }
  }

  async function fazerPedido() {
    if (!await validarEntregaAntesDeEnviar()) return;
    if (!validarCupomAntesDeEnviar()) return;

    let empresaid = getActiveStoreId() || "";
    let empresanome = localStorage.getItem("empresanome") || "";

    // ✅ Prioriza o contexto sobre o localStorage
    if (dadosEmpresa?.pk) {
      empresaid = dadosEmpresa.pk;
      console.log("🔄 fazerPedido - Usando empresaid do contexto:", empresaid);
    }

    // ✅ Prioriza o contexto sobre o localStorage
    if (dadosEmpresa?.empresaNome) {
      empresanome = dadosEmpresa.empresaNome;
      console.log("🔄 fazerPedido - Usando empresanome do contexto:", empresanome);
    }

    const complemento = localStorage.getItem("complementoEntrega") || "";

    // Debug logging para investigar localStorage
    console.log("🔍 fazerPedido - Debug localStorage:");
    console.log("📋 empresaid (final):", empresaid);
    console.log("📋 empresanome (final):", empresanome);
    console.log("🏢 localStorage completo:", {
      empresaid: getActiveStoreId(),
      empresanome: localStorage.getItem("empresanome")
    });

    if (dadosEmpresa) {
      console.log("📊 dadosEmpresa.empresaId:", dadosEmpresa.pk);
      console.log("📊 dadosEmpresa.empresaNome:", dadosEmpresa.empresaNome);
    }

    const nome = (localStorage.getItem("nome") || "").trim();
    const telefone = (localStorage.getItem("telefone") || "").trim();
    const endereco = localStorage.getItem("enderecoEntrega") || "";
    const enderecoLat = localStorage.getItem("latitudeEntrega") || "";
    const enderecoLng = localStorage.getItem("longitudeEntrega") || "";

    const tipoAgendamento = localStorage.getItem("tipoAgendamento") || "";
    const dataAgendamento = localStorage.getItem("dataAgendamento") || "";
    const horaAgendamento = localStorage.getItem("horaAgendamento") || "";

    const formaPagamento = arrayFormaPagamento[0].pagamento;
    const troco = calcularValorTroco(valorTotal, arrayFormaPagamento);
    const valorPagoDinheiro = obterValorPagoDinheiro(arrayFormaPagamento);

    const pkCliente = "";

    const newToken = cartApiHeaders().token;

    let objRequest = {
      "nomeCliente": nome,
      "telefoneCliente": telefone,
      lojas: [{ "empresaLojaId": empresaid, "empresaLojaNome": empresanome }],
      "pularEndereco": false,
      "endereco": endereco || "",
      "complemento": complemento || "",
      "enderecoLat": enderecoLat,
      "enderecoLng": enderecoLng,
      "clienteid": pkCliente.replaceAll(/#/g, '%23'),
      "responsavelid": "",
      "empresaid": empresaid || "",
      "responsaveis": [dadosEmpresa.usuarioPush], //[pkUsuario.replaceAll(/#/g, '%23')],
      "interno": false,
      "produtos": listaItemProdutos,
      "formaPagamento": formaPagamento,
      "valorPagoDinheiro": valorPagoDinheiro,
      "troco": troco,
      "taxaEntrega": taxaEntrega,
      "tempoEntrega": localStorage.getItem('tempoEntrega') || '',
      "entrega": readDeliverySelection(),
      "desconto": (() => {
        const descontoFloat = parseFloat(props.desconto?.replace(/\./g, '').replace(/\,/g, '.')) || 0;
        const resgateFloat = props.resgateCashBack || 0;
        return (descontoFloat + resgateFloat).toLocaleString('pt-br', { minimumFractionDigits: 2 });
      })(),
      "taxaServico": taxaServico,
      "internet": true,
      "cupom": props.desconto ? true : false,
      "resgateCashBack": props.resgateCashBack ? true : false,
      "agendamento": tipoAgendamento == "AGENDADO"
        ? "AGENDADO | " + formatarData(dataAgendamento) + " às " + formatarHora(horaAgendamento)
        : ""
    };

    if (endereco == "RETIRADA" || dadosEmpresa.tipoConfiguracoesEntrega != "raio") {
      objRequest.pularEndereco = true;
    }

    setShowLoading(true);

    requestService(incluirProjeto.url, {
      method: incluirProjeto.method,
      headers: [
        ["token", newToken]
      ],
      body: JSON.stringify(objRequest),
      credentials: 'include'
    },
      history,
      (response: any) => {

        console.log("response", response);

        if (response.message && response.message.pk) {
          // atualiza cardápio (estoque) com os dados retornados pela API
          const empresaAtualizada = response.message.vo?.empresa;
          if (empresaAtualizada) {
            setDadosEmpresa((atual: any) => ({
              ...empresaAtualizada,
              // A resposta do pedido traz a chave do S3; o contexto já tem a URL assinada.
              urlLogo: /^https?:\/\//.test(empresaAtualizada.urlLogo || '')
                ? empresaAtualizada.urlLogo
                : (atual?.pk === empresaAtualizada.pk ? atual.urlLogo : empresaAtualizada.urlLogo)
            }));
            if (empresaAtualizada.pk && empresaAtualizada.urlLogo && !/^https?:\/\//.test(empresaAtualizada.urlLogo)) {
              void carregarEmpresa(empresaAtualizada.pk, true);
            }
          }

          // Analytics: Purchase
          try {
            const valorPurchase = parseFloat(String(valorTotal || '0').replace(/\./g, '').replace(/\,/g, '.')) || 0;
            const descontoPurchase = parseFloat(String(props.desconto?.valor || 0).toString().replace(/\./g, '').replace(/\,/g, '.')) || 0;
            const formaPagamento = (arrayFormaPagamento && arrayFormaPagamento[0] && arrayFormaPagamento[0].pagamento) || undefined;
            analytics.trackPurchase({
              orderId: String(response.message.pk),
              valor: valorPurchase,
              items: listaItemProdutos || [],
              paymentType: formaPagamento,
              coupon: props.desconto?.codigo,
              discount: descontoPurchase,
              extras: {
                entrega: endereco === 'RETIRADA' ? 'retirada' : 'entrega',
              },
            });
          } catch (e) { /* noop */ }

          setListaItemProdutos([]);

          props.closeAction();


        }

      },
      (error: any) => {
        console.log("error", error);
        if (error.changed && Array.isArray(error.produtos)) setListaItemProdutos(error.produtos);
        if (error.entrega) atualizarEntrega(error.entrega);
        setTextToast(error.message || error.errors?.[0]?.message || 'Revise os itens do carrinho.');
        setShowToast(true);

      }).finally(() => {
        setShowLoading(false);
      });

  }

  // Valida estoque, gera pagamento Pix e armazena a pré-ordem em uma única requisição ao backend.
  async function armazenarPedido() {
    if (!await validarEntregaAntesDeEnviar()) return;
    if (!validarCupomAntesDeEnviar()) return;

    let empresaid = getActiveStoreId() || "";
    let empresanome = localStorage.getItem("empresanome") || "";

    // ✅ Prioriza o contexto sobre o localStorage
    if (dadosEmpresa?.pk) {
      empresaid = dadosEmpresa.pk;
      console.log("🔄 armazenarPedido - Usando empresaid do contexto:", empresaid);
    }

    // ✅ Prioriza o contexto sobre o localStorage
    if (dadosEmpresa?.empresaNome) {
      empresanome = dadosEmpresa.empresaNome;
      console.log("🔄 armazenarPedido - Usando empresanome do contexto:", empresanome);
    }

    const complemento = localStorage.getItem("complementoEntrega") || "";

    // Debug logging para investigar localStorage
    console.log("🔍 fazerPedido - Debug localStorage:");
    console.log("📋 empresaid (final):", empresaid);
    console.log("📋 empresanome (final):", empresanome);
    console.log("🏢 localStorage completo:", {
      empresaid: getActiveStoreId(),
      empresanome: localStorage.getItem("empresanome")
    });

    if (dadosEmpresa) {
      console.log("📊 dadosEmpresa.empresaId:", dadosEmpresa.pk);
      console.log("📊 dadosEmpresa.empresaNome:", dadosEmpresa.empresaNome);
    }

    const nome = (localStorage.getItem("nome") || "").trim();
    const telefone = (localStorage.getItem("telefone") || "").trim();
    const endereco = localStorage.getItem("enderecoEntrega") || "";
    const enderecoLat = localStorage.getItem("latitudeEntrega") || "";
    const enderecoLng = localStorage.getItem("longitudeEntrega") || "";

    const tipoAgendamento = localStorage.getItem("tipoAgendamento") || "";
    const dataAgendamento = localStorage.getItem("dataAgendamento") || "";
    const horaAgendamento = localStorage.getItem("horaAgendamento") || "";

    const formaPagamento = arrayFormaPagamento[0].pagamento;
    const troco = calcularValorTroco(valorTotal, arrayFormaPagamento);
    const valorPagoDinheiro = obterValorPagoDinheiro(arrayFormaPagamento);

    const pkCliente = "";

    const newToken = cartApiHeaders().token;

    let objRequest = {
      "valorTotal": parseFloat(valorTotal?.replace(/\./g, '').replace(/\,/g, '.') || '0'),
      "nomeCliente": nome,
      "telefoneCliente": telefone,
      lojas: [{ "empresaLojaId": empresaid, "empresaLojaNome": empresanome }],
      "pularEndereco": false,
      "endereco": endereco || "",
      "complemento": complemento || "",
      "enderecoLat": enderecoLat,
      "enderecoLng": enderecoLng,
      "clienteid": pkCliente.replaceAll(/#/g, '%23'),
      "responsavelid": "",
      "empresaid": empresaid || "",
      "responsaveis": [dadosEmpresa.usuarioPush], //[pkUsuario.replaceAll(/#/g, '%23')],
      "interno": false,
      "produtos": listaItemProdutos,
      "formaPagamento": formaPagamento,
      "valorPagoDinheiro": valorPagoDinheiro,
      "troco": troco,
      "taxaEntrega": taxaEntrega,
      "tempoEntrega": localStorage.getItem('tempoEntrega') || '',
      "entrega": readDeliverySelection(),
      "desconto": (() => {
        const descontoFloat = parseFloat(props.desconto?.replace(/\./g, '').replace(/\,/g, '.')) || 0;
        const resgateFloat = props.resgateCashBack || 0;
        return (descontoFloat + resgateFloat).toLocaleString('pt-br', { minimumFractionDigits: 2 });
      })(),
      "taxaServico": taxaServico,
      "internet": true,
      "cupom": props.desconto ? true : false,
      "resgateCashBack": props.resgateCashBack ? true : false,
      "agendamento": tipoAgendamento == "AGENDADO"
        ? "AGENDADO | " + formatarData(dataAgendamento) + " às " + formatarHora(horaAgendamento)
        : ""
    };

    if (endereco == "RETIRADA" || dadosEmpresa.tipoConfiguracoesEntrega != "raio") {
      objRequest.pularEndereco = true;
    }

    setShowLoading(true);

    requestService(armazenarProjeto.url, {
      method: armazenarProjeto.method,
      headers: [
        ["token", newToken]
      ],
      body: JSON.stringify(objRequest),
      credentials: 'include'
    },
      history,
      (response: any) => {

        console.log("response armazenarPedido", response);

        if (response && response.pk && response.pix) {
          setIdPagamento(response.pix.id);
          setQRCode(response.pix.qr_code);
          setQRCodeData(response.pix.qr_code_base64);
          setValorPagamento(response.pix.transaction_amount);
          setShowModalQrCode(true);
          verificarPagamentoPedido(response.pix.id);
        }
        else {
          setTextToast("Ocorreu um erro ao armazenar o pedido, entre em contato com o suporte.");
          setShowToast(true);
        }

      },
      (error: any) => {
        console.log("error", error);
        if (error.changed && Array.isArray(error.produtos)) setListaItemProdutos(error.produtos);
        if (error.entrega) atualizarEntrega(error.entrega);
        setTextToast(error.message || error.errors?.[0]?.message || 'Revise os itens do carrinho.');
        setShowToast(true);

      }).finally(() => {
        setShowLoading(false);
      });

  }

  async function closeModalConfirmarCelularSimple() {
    setShowModalConfirmarCelular(false);
  }

  async function closeModalConfirmarCelular(nome: any, celular: any) {
    setShowModalConfirmarCelular(false);
    localStorage.setItem("nome", nome);
    localStorage.setItem("telefone", celular);
    confirmarPedido();
  }

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar className="pedido-fluxo-modal-toolbar">

          <IonButtons slot="start" className="pedido-fluxo-back-buttons">
            <IonButton aria-label="Voltar" className="pedido-fluxo-back-button" fill="clear" onClick={() => props.closeActionSimple(arrayFormaPagamento)}>
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
          </IonButtons>

          <IonTitle className="ion-text-wrap">Fechamento</IonTitle>

        </IonToolbar>


      </IonHeader>

      <IonContent fullscreen={false}>

        <IonGrid>

          {/* <IonRow style={{ "borderBottom": "1px solid #e0e0e0" }}>
            <IonCol size="6" style={{ display: 'flex', alignItems: 'center' }}>
              <IonLabel>Desconto:</IonLabel>
            </IonCol>
            <IonCol size="6" style={{ textAlign: 'right' }}>
              <IonSelect
                placeholder="Selecione"
                value={desconto}
                onIonChange={(e) => {
                  setDesconto(e.detail.value); // Atualiza o valor do desconto
                }}
              >
                {opcoesDesconto.map((opcao, index) => (
                  <IonSelectOption key={index} value={opcao.value}>
                    {opcao.label}
                  </IonSelectOption>
                ))}
              </IonSelect>
            </IonCol>

          </IonRow> */}

          <IonRow>
            <IonCol size="12" style={{}}>
              <IonLabel>Escolha a forma de pagamento:</IonLabel>
            </IonCol>
          </IonRow>

          {/* Seção: Pagar agora - Pix Automatizado */}
          {dadosEmpresa.formaPagamento?.some((item: any) =>
            item.exibirDelivery && item.tipo === "Pix Automatizado"
          ) && (
              <>
                <IonRow style={{ marginTop: '10px' }}>
                  <IonCol size="12">
                    <div style={{
                      backgroundColor: '#f5f5f5',
                      padding: '16px',
                      borderRadius: '12px',
                      border: '1px solid #e9ecef'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <h3 style={{
                          margin: '0',
                          color: 'var(--ion-color-primary)',
                          fontSize: '18px',
                          fontWeight: 'bold'
                        }}>
                          Pagar agora
                        </h3>
                        <span style={{
                          backgroundColor: 'var(--ion-color-success)',
                          color: 'white',
                          padding: '4px 12px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: 'bold'
                        }}>
                          Mais rápido
                        </span>
                      </div>
                      <p style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        margin: '0 0 16px 0'
                      }}>
                        Pague com agilidade e segurança
                      </p>

                      {dadosEmpresa.formaPagamento?.map((item: any, index: any) => {
                        if (!item.exibirDelivery || item.tipo !== "Pix Automatizado") return null;

                        const isSelected = arrayFormaPagamento.length > 0 &&
                          arrayFormaPagamento[0].pagamento === item.nome &&
                          arrayFormaPagamento[0].tipo === item.tipo;

                        return (
                          <div
                            key={index}
                            onClick={() => handleAdicionarFormaPagamento(item.nome, item.tipo)}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '12px',
                              backgroundColor: 'white',
                              borderRadius: '8px',
                              border: isSelected ? "2px solid var(--ion-color-primary)" : "1px solid #e0e0e0",
                              cursor: 'pointer',
                              // transition: 'all 0.3s ease'
                            }}
                          >
                            <div style={{
                              width: '50px',
                              height: '50px',
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '12px'
                            }}>
                              <IonImg
                                src={iconPix}
                                alt="Pix"
                                style={{ width: "30px", height: "30px" }}
                              />
                            </div>
                            <div style={{ flex: 1 }}>
                              <div style={{
                                fontWeight: 'bold',
                                fontSize: '16px',
                                color: '#333'
                              }}>
                                {item.nome}
                              </div>
                              <div style={{
                                fontSize: '12px',
                                color: '#6c757d',
                                marginTop: '2px'
                              }}>
                                Pagamento com Pix online
                              </div>
                              <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                backgroundColor: 'var(--ion-color-success)',
                                color: 'white',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '11px',
                                marginTop: '4px'
                              }}>
                                <IonIcon icon={flash} style={{ fontSize: '12px' }} />
                                Entrega mais rápida
                              </div>
                            </div>
                            {/* <div style={{
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              border: isSelected ? '6px solid var(--ion-color-primary)' : '2px solid #dee2e6',
                              backgroundColor: isSelected ? 'var(--ion-color-primary)' : 'transparent'
                            }} /> */}
                          </div>
                        );
                      })}
                    </div>
                  </IonCol>
                </IonRow>
              </>
            )}

          {/* Seção: Pagar na entrega - Outros tipos */}
          {dadosEmpresa.formaPagamento?.some((item: any) =>
            item.exibirDelivery && item.tipo !== "Pix Automatizado"
          ) && (
              <>
                <IonRow style={{ marginTop: '10px' }}>
                  <IonCol size="12">
                    <div style={{
                      backgroundColor: '#f5f5f5',
                      padding: '16px',
                      borderRadius: '12px',
                      border: '1px solid #e9ecef'
                    }}>
                      <h3 style={{
                        margin: '0 0 16px 0',
                        color: '#333',
                        fontSize: '18px',
                        fontWeight: 'bold'
                      }}>
                        Pagar na entrega
                      </h3>

                      <div className="pagamento-entrega-list">
                        {dadosEmpresa.formaPagamento?.map((item: any, index: any) => {
                          if (!item.exibirDelivery || item.tipo === "Pix Automatizado") return null;

                          const isSelected = arrayFormaPagamento.length > 0 &&
                            arrayFormaPagamento[0].pagamento === item.nome &&
                            arrayFormaPagamento[0].tipo === item.tipo;
                          const isDinheiro = isPagamentoDinheiro({ pagamento: item.nome, tipo: item.tipo });
                          const campoSelecionado = isSelected ? arrayFormaPagamento[0] : null;

                          return (
                            <div
                              key={index}
                              className={`pagamento-entrega-option${isSelected ? " selected" : ""}`}
                            >
                              <div
                                className="pagamento-entrega-option-header"
                                onClick={() => handleAdicionarFormaPagamento(item.nome, item.tipo)}
                              >
                                <IonIcon
                                  className="pagamento-entrega-icon"
                                  icon={getIconeFormaPagamentoEntrega(item)}
                                />
                                <div className="pagamento-entrega-title">
                                  {item.nome}
                                </div>
                              </div>

                              {isSelected && isDinheiro && renderPagamentoDinheiroDetalhes(campoSelecionado, 0)}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </IonCol>
                </IonRow>
              </>
            )}


        </IonGrid>

        <IonModal
          className="mini-modal"
          isOpen={showModalConfirmarCelular}
          onDidDismiss={() => { setShowModalConfirmarCelular(false); }}
          style={{
            '--backdrop-opacity': '0.4',              // opacidade do cinza
            '--backdrop-background': 'rgba(0,0,0,0.4)' // cor exata do overlay
          }}
        >
          <ConfirmarCelular nome={localStorage.getItem("nome") || ""} celular={localStorage.getItem("telefone") || ""} logado={props.logado} closeActionSimple={closeModalConfirmarCelularSimple} closeAction={closeModalConfirmarCelular}></ConfirmarCelular>
        </IonModal>


        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>
      <IonFooter>

        <IonToolbar>


          <IonGrid>

            {/* <IonRow>
              <IonCol size="6">
                <IonLabel>Restante:</IonLabel>
              </IonCol>
              <IonCol size="6" style={{ textAlign: 'right' }}>
                <IonLabel>R$ {calcularValorRestante(valorTotal, arrayFormaPagamento).toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}</IonLabel>
              </IonCol>
            </IonRow>*/}











            <IonRow>
              <IonCol size="6" style={{ fontWeight: 'bold' }}>
                <IonLabel>Subtotal:</IonLabel>
              </IonCol>
              <IonCol size="6" style={{ textAlign: 'right', fontWeight: 'bold' }}>
                <IonLabel>R$ {valorTotalProdutos || "0,00"}</IonLabel>
              </IonCol>
            </IonRow>

            <IonRow hidden={!props.desconto && !props.resgateCashBack}>
              <IonCol size="6" style={{}}>
                <IonLabel>Desconto:</IonLabel>
              </IonCol>
              <IonCol size="6" style={{ textAlign: 'right' }}>
                <IonLabel>- R$ {(() => {
                  try {
                    const descontoFloat = parseFloat(props.desconto?.replace(/\./g, '').replace(/\,/g, '.')) || 0;
                    const resgateFloat = props.resgateCashBack || 0;
                    return (descontoFloat + resgateFloat).toLocaleString('pt-br', { minimumFractionDigits: 2 });
                  } catch (e) {
                    return "0,00";
                  }
                })()}</IonLabel>
              </IonCol>
            </IonRow>

            <IonRow style={{ "borderBottom": "1px solid #e0e0e0" }}>
              <IonCol size="6" style={{}}>
                <IonLabel>Taxa de entrega:</IonLabel>
              </IonCol>
              <IonCol size="6" style={{ textAlign: 'right' }}>
                <IonLabel>R$ {taxaEntrega || "0,00"}</IonLabel>
              </IonCol>
            </IonRow>

            <IonRow>
              <IonCol size="6" style={{ fontWeight: 'bold', fontSize: "20px" }}>
                <IonLabel>Valor Total:</IonLabel>
              </IonCol>
              <IonCol size="6" style={{ textAlign: 'right', fontWeight: 'bold', fontSize: "20px" }}>
                <IonLabel>R$ {valorTotal || "0,00"}</IonLabel>
              </IonCol>
            </IonRow>

            <IonRow>

              <IonCol>
                <IonButton style={{ height: "46px", fontSize: "18px" }} expand="block"
                  type="submit"
                  onClick={async () => {

                    if (!validarPagamentoDinheiro()) {
                      return false;
                    }


                    let valorRestante = calcularValorRestante(valorTotal, arrayFormaPagamento);

                    if (valorRestante <= 0) {

                      if (!await validarEntregaAntesDeEnviar()) return;
                      if (listaItemProdutos?.length === 0) {
                        setTextToast("Selecione pelo menos um produto.");
                        setShowToast(true);
                      } else if (cartNumber(valorTotalProdutos) < cartNumber(dadosEmpresa.pedidoMinimo)) {
                        setTextToast("Pedido mínimo de R$ " + (dadosEmpresa.pedidoMinimo || "0,00") + " em produtos.");
                        setShowToast(true);
                      } else {
                        const validacaoCupom = validateCheckoutCoupon(dadosEmpresa.configuracoesCupom,
                          props.cupom, props.desconto, valorTotalProdutos, taxaEntrega);
                        if (validacaoCupom.valid) setShowModalConfirmarCelular(true);
                        else {
                          setTextToast(validacaoCupom.message || "Desconto inválido.");
                          setShowToast(true);
                        }
                      }

                    } else {
                      setTextToast("Ainda falta R$ " + valorRestante.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) + " para fechar. Selecione a forma de pagamento.");
                      setTextToast("Selecione a forma de pagamento.");
                      setShowToast(true);
                    }

                  }}
                >
                  Continuar
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>




        </IonToolbar>
      </IonFooter >

      <IonModal
        className="medium-modal"
        isOpen={showRevisarPedido}
        onDidDismiss={() => { setShowRevisarPedido(false); }}
        style={{
          '--backdrop-opacity': '0.4',              // opacidade do cinza
          '--backdrop-background': 'rgba(0,0,0,0.4)' // cor exata do overlay
        }}
      >
        <RevisarPedido
          valorTotal={valorTotal}
          enderecoEntrega={localStorage.getItem("enderecoEntrega") || ""}
          complementoEntrega={localStorage.getItem("complementoEntrega") || ""}
          formaPagamento={arrayFormaPagamento[0]?.tipo || ""}
          tempoEntrega={localStorage.getItem("tempoEntrega") || ""}
          taxaEntrega={localStorage.getItem("taxaEntrega") || "0,00"}
          isRetirada={(localStorage.getItem("enderecoEntrega") || "") === "RETIRADA"}
          desconto={
            (() => {
              const descontoFloat = parseFloat(props.desconto?.replace(/\./g, '').replace(/\,/g, '.')) || 0;
              const resgateFloat = props.resgateCashBack || 0;
              return (descontoFloat + resgateFloat).toLocaleString('pt-br', { minimumFractionDigits: 2 });
            })()
          }
          empresaEndereco={dadosEmpresa.empresaEndereco || ""}
          tipoAgendamento={localStorage.getItem("tipoAgendamento") || ""}
          dataAgendamento={localStorage.getItem("dataAgendamento") || ""}
          horaAgendamento={localStorage.getItem("horaAgendamento") || ""}
          closeAction={() => {
            setShowRevisarPedido(false);

            const nomeLocal = (localStorage.getItem("nome") || "").trim();
            const telefoneLocal = (localStorage.getItem("telefone") || "").trim();
            const telefoneDigits = telefoneLocal.replace(/\D/g, "");
            const telefoneValido = telefoneDigits.startsWith("55") && (telefoneDigits.length === 13);

            if (!nomeLocal || !telefoneValido) {
              setTextToast("Informe nome e celular válidos.");
              setShowToast(true);
              setShowModalConfirmarCelular(true);
              return;
            }

            // Verifica se a forma de pagamento é Mercado Pago
            const tipoFormaPagamentoSelecionada = arrayFormaPagamento[0]?.tipo;

            console.log("tipoFormaPagamentoSelecionada", tipoFormaPagamentoSelecionada);

            if (tipoFormaPagamentoSelecionada == "Pix Automatizado") {
              // Valida estoque + gera pagamento Pix + armazena pré-ordem em uma única requisição
              armazenarPedido();
            } else {
              // Para outras formas de pagamento, faz o pedido direto
              fazerPedido();
            }
          }}
          closeActionSimple={() => setShowRevisarPedido(false)}
        /> </IonModal>


      <IonModal className="fullscreen-modal" isOpen={showModalQrCode} onDidDismiss={() => {
        setShowModalQrCode(false);
        pararVerificacaoPagamento(); // Para a verificação quando o modal for fechado
      }}>
        <IonHeader className="ion-no-border">
          <IonToolbar className="pedido-fluxo-modal-toolbar">
            <IonButtons slot="start" className="pedido-fluxo-back-buttons">
              <IonButton aria-label="Voltar" className="pedido-fluxo-back-button" fill="clear" onClick={() => {
                setShowModalQrCode(false);
                pararVerificacaoPagamento(); // Para a verificação quando clicar em voltar
              }}>
                <IonIcon icon={arrowBack} />
              </IonButton>
            </IonButtons>
            <IonTitle className="ion-text-wrap"><span className="modal-title-text">Detalhes do pagamento</span></IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>




          <IonCard className="div-qrcode-pagamento">
            <IonCardContent>

              {/* Título Assinatura */}
              <IonLabel className="qr-code-pagamento">
                <h2><b>{localStorage.getItem("empresanome") || "Pedido"}</b></h2>
              </IonLabel>

              {/* Valor do pagamento */}
              <IonLabel>
                <p className="payment-title">Pague <b>R$ {valorTotal?.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}</b> via <b>Pix</b></p>
              </IonLabel>

              <IonLabel className="qr-code-pagamento-margin">
                <h3>Para pagar, escolha uma destas opções:</h3>
              </IonLabel>

              {/* Código QR */}
              <IonCardContent className="qr-code-pagamento">
                <IonLabel>
                  <p>Código QR</p>
                </IonLabel>
                {qrCodeData && <img src={`data:image/png;base64,${qrCodeData}`} alt="QR Code" />}
              </IonCardContent>

              {/* Código de pagamento e botão de cópia */}
              <IonCardContent className="qr-code-pagamento">
                <IonLabel>
                  <p>Código de pagamento</p>
                </IonLabel>
                <div className="copy-code-container">
                  {/* Substituído por IonTextarea */}
                  <IonTextarea
                    readonly={true}
                    style={{ "--background": "#eeeeee" }}
                    rows={2}
                    value={qrCode}
                  />
                  <IonButton fill="clear" onClick={() => {
                    navigator.clipboard.writeText(qrCode);
                    setTextToast("Código copiado");
                    setShowToast(true);
                  }}>
                    <IonIcon color="primary" icon={copy} />
                  </IonButton>
                </div>

              </IonCardContent>

              <IonLabel className="qr-code-pagamento">
                Código válido por: <h1>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h1>
              </IonLabel>
              {/* Instruções de como pagar */}
              <IonCardContent>

                <IonLabel>
                  <p><b>Como pagar?</b></p>
                  <ol>
                    <li>Entre no app ou site do seu banco e escolha a opção de pagamento via Pix.</li>
                    <li>Escaneie o código QR ou copie e cole o código de pagamento.</li>
                    <li>Pronto! Agora é só aguardar o pagamento ser processado.</li>
                  </ol>
                </IonLabel>
              </IonCardContent>


            </IonCardContent>
          </IonCard>








        </IonContent>

      </IonModal>

    </>


  );
};

export default OrdensFechar;
